import React from 'react';
import { useMemo } from 'react';
import Icon from '../Icon';
import {
  StyledInputIconWrapper,
  StyledInputWrapper,
  StyledTextArea,
  StyledTextAreaIcon,
} from './styles/Inputs.styled';
import { InputProps } from './types/Input.types';

const TextArea: React.FC<
  InputProps & React.InputHTMLAttributes<HTMLTextAreaElement>
> = ({
  inputSize = 'medium',
  inputState = 'default',
  icon,
  wrapperClassName,
  label,
  helperText,
  message,
  showMessageIcon = true,
  ...props
}) => {
  const messageIcon = useMemo(() => {
    switch (inputState) {
      case 'default':
      default:
        return null;

      case 'success':
        return <Icon name="check-circle" />;

      case 'error':
      case 'warning':
        return <Icon name="warning" />;
    }
  }, [inputState]);

  return (
    <StyledInputWrapper
      className={wrapperClassName}
      $inputState={inputState}
      $hasIcon={!!icon}
    >
      {label && <label htmlFor={props.id}>{label}</label>}
      <StyledInputIconWrapper>
        <StyledTextArea
          as="textarea"
          $inputSize={inputSize}
          $inputState={inputState}
          $hasIcon={!!icon}
          {...props}
        />
        {typeof icon == 'string' && (
          <StyledTextAreaIcon name={icon} $inputSize={inputSize} />
        )}
        {typeof icon == 'object' && icon}
      </StyledInputIconWrapper>
      {helperText && <span className="helper-text">{helperText}</span>}
      {message && (
        <span className="message">
          {showMessageIcon && messageIcon}
          <span>{message}</span>
        </span>
      )}
    </StyledInputWrapper>
  );
};

export default TextArea;
